import { render, staticRenderFns } from "./redEnvelopes.vue?vue&type=template&id=18a57fb9&scoped=true"
import script from "./redEnvelopes.vue?vue&type=script&lang=js"
export * from "./redEnvelopes.vue?vue&type=script&lang=js"
import style0 from "./redEnvelopes.vue?vue&type=style&index=0&id=18a57fb9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a57fb9",
  null
  
)

export default component.exports